import React, { useState } from 'react'
import styles from "./Messages.module.scss"
import { Col, Container, Row } from 'reactstrap'
import DynamicDatatable from '../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable'
import StockMonitoringDetails from '../../../../components/AdminPortalComponents/BusinessManagement/StockMonitoring/StockMonitoringDetails'
import MessagesComp from '../../../../components/AdminPortalComponents/Support&Communication/Messages/Messages.comp'
import ComponentBackButton from '../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton'
function Messages() {
    const [messageDetails, setMessageDetails] = useState(false)
    const tableData = [
        { userType: "Customers", unreadMessages: 5, totalMessagse: 120 },
        { userType: "Sellers", unreadMessages: 5, totalMessagse: 120 },
        { userType: "Delivery Agents", unreadMessages: 5, totalMessagse: 120 },
    ]
    const tableCols = [
        {
            name: "User Type",
            selector: (row) => row.userType,
        },
        {
            name: "Unread Messages",
            selector: (row) => row.unreadMessages,
        },
        {
            name: "Total Messages",
            selector: (row) => row.totalMessagse,
        },
    ]
    return (
        <div className={styles.mainContainer}>
            <Container className={styles.filterTableWrapper}>
                <DynamicDatatable data={tableData} columns={tableCols} type={"yellow"} />
            </Container>
            {!messageDetails &&
                <>
                    <div className="p-3 d-flex align-items-center justify-content-between">
                        <div className={`fw-semibold fs-4 ${styles.text} `}>Messages </div>
                    </div>
                    <Container className={styles.filterTableWrapper}>
                        <MessagesComp onClick={() => setMessageDetails(true)} />
                    </Container>
                </>
            }
            {messageDetails &&
                <Row className='row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-xl-2'>
                    <Col>
                        <Container fluid className={styles.orderWrapper}>
                            <ComponentBackButton onClick={() => setMessageDetails(false)} />

                            <div className={styles.msgInfo}>
                                <h5 className={styles.msgInfoText}>Message Information</h5>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text1}>Message ID:</div>
                                <div>001</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.blueText}>Sender:</div>
                                <div>Jhon doe</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.blueText}>Recepient:</div>
                                <div>John</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text1}>User Type:</div>
                                <div>Admin</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text1}>Subject:</div>
                                <div>Order Inquiry</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.yellowText}>Received Date:</div>
                                <div>12-11-2024</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text1}>Status:</div>
                                <div className={styles.redText}>Unread</div>
                            </div>

                            <div>
                                <div className={styles.msgInfoText2}>Message Content:</div>
                                <div className={styles.msg}>Hello, I have a question regarding my recent order #12345. Could you please provide an update on the shipping status?</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text1}>Response Options:</div>
                                <div>001</div>
                            </div>

                            <div >
                                <div className={styles.msgInfoText2}>Reply:</div>
                                <div>Compose and send a response directly to the sender</div>
                            </div>

                            <div className={styles.cont}>
                                <div className={styles.text2}>Forward:</div>
                                <div>Send the message to another department or user for further action</div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            }
        </div>
    )
}

export default Messages
